import React from 'react';
import { X, Download } from 'lucide-react';

const PolicyModal = ({ isOpen, onClose, title, content, onDownload }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div 
        className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[80vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-emerald-200">
          <h2 className="text-2xl font-bold text-emerald-800">{title}</h2>
          <div className="flex items-center space-x-2">
            {onDownload && (
              <button
                onClick={onDownload}
                className="p-2 hover:bg-emerald-100 rounded-lg transition-colors"
                title="Download"
              >
                <Download className="w-5 h-5 text-emerald-600" />
              </button>
            )}
            <button
              onClick={onClose}
              className="p-2 hover:bg-emerald-100 rounded-lg transition-colors"
            >
              <X className="w-5 h-5 text-emerald-600" />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          <div className="prose prose-emerald max-w-none">
            <pre className="whitespace-pre-wrap font-sans text-sm text-emerald-800 leading-relaxed">
              {content}
            </pre>
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-emerald-200">
          <button
            onClick={onClose}
            className="btn-primary w-full"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PolicyModal;
